import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  { name: 'creditorName', label: 'Creditor Name', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'amount', label: 'Amount', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'monthlyPayment', label: 'Monthly Payment', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'lienPriorityType', label: 'Lien Priority', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'sourceOfFunds', label: 'Source of Funds', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'otherFundDescription', label: 'Description', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'monthsDeferred', label: 'Months Deferred', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'deferredType', label: 'Deferred Type', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'excludePayment', label: 'Payment Excluded', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'isSubordinate', label: 'Subordinate', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'heloc', label: 'HELOC', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'isAffordableLoan', label: 'Affordable Loan', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'highLimit', label: 'High Limit', levelType: AutoLockFormsLevelType.FIELD },
];

export const additionalFinancingForm = {
  name: FormNames.ADDITIONAL_FINANCING,
  label: 'Additional Financing',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
